import { FeatureFlag } from '@ps/web-core-enums';

import type { PageResponseWithRouteMatch } from '@swf/core/models/cms';
import type { RootState } from '@swf/core/store';
import { select } from '@swf/core/store';

import { sportsEmbeddedHistoricalBets } from './sportsBasicLayout/response/sportsEmbeddedHistoricalBets';
import { sportsEmbeddedMyBets } from './sportsBasicLayout/response/sportsEmbeddedMyBets';
import { sportsEmbeddedSettings } from './sportsBasicLayout/response/sportsEmbeddedSettings';
import { sportsAnimalRacingFuture } from './sportsLayout/response/sportsAnimalRacingFuture';
import { sportsAnimalRacingFutureMarket } from './sportsLayout/response/sportsAnimalRacingFutureMarket';
import { sportsAnimalRacingMeetings } from './sportsLayout/response/sportsAnimalRacingMeetings';
import { sportsAnimalRacingNext } from './sportsLayout/response/sportsAnimalRacingNext';
import { sportsAnimalRacingRace } from './sportsLayout/response/sportsAnimalRacingRace';
import { sportsAnimalRacingSpecials } from './sportsLayout/response/sportsAnimalRacingSpecials';
import { sportsCompetition } from './sportsLayout/response/sportsCompetition';
import { sportsCompetitionOutrights } from './sportsLayout/response/sportsCompetitionOutrights';
import { sportsCompetitions } from './sportsLayout/response/sportsCompetitions';
import { sportsEvent } from './sportsLayout/response/sportsEvent';
import { sportsGolfCompetition } from './sportsLayout/response/sportsGolfCompetition';
import { sportsGolfMatches } from './sportsLayout/response/sportsGolfMatches';
import { sportsHistoricalBets } from './sportsLayout/response/sportsHistoricalBets';
import { sportsHome } from './sportsLayout/response/sportsHome';
import { sportsInPlay } from './sportsLayout/response/sportsInPlay';
import { sportsInPlaySport } from './sportsLayout/response/sportsInPlaySport';
import { sportsLanding } from './sportsLayout/response/sportsLanding';
import { sportsMatchFiltering } from './sportsLayout/response/sportsMatchFiltering';
import { sportsMyBets } from './sportsLayout/response/sportsMyBets';
import { sportsPromotion } from './sportsLayout/response/sportsPromotion';
import { sportsPromotions } from './sportsLayout/response/sportsPromotions';
import { sportsSettings } from './sportsLayout/response/sportsSettings';
import { sportsSpecials } from './sportsLayout/response/sportsSpecials';
import { sportsSport } from './sportsLayout/response/sportsSport';
import { sportsSportInPlay } from './sportsLayout/response/sportsSportInPlay';
import { sportsSelfExcluded } from './sportsSelfExcludedLayout/response/sportsSelfExcluded';
import { sportsSelfExcludedHistoricalBets } from './sportsSelfExcludedLayout/response/sportsSelfExcludedHistoricalBets';
import { sportsSelfExcludedMyBets } from './sportsSelfExcludedLayout/response/sportsSelfExcludedMyBets';

export const getResponses = (rootState: RootState): PageResponseWithRouteMatch[] => {
  const isIspAnimalRacingSpecialsPagesEnabled = select.feature.check(
    rootState,
    FeatureFlag.ISPAnimalRacingSpecials
  );

  const isLandingPagePopularAccumulatorsEnabled = select.feature.check(
    rootState,
    FeatureFlag.ISPEnableLandingPagePopularAccumulators
  );

  const { eventTypeId } = select.sports.getUrlParams(rootState);

  return [
    /* Sports Layout */
    sportsAnimalRacingFuture({ eventTypeId: Number(eventTypeId) }),
    sportsAnimalRacingFutureMarket,
    sportsAnimalRacingMeetings({ eventTypeId: Number(eventTypeId) }),
    sportsAnimalRacingNext({
      eventTypeId: Number(eventTypeId),
      isLandingPagePopularAccumulatorsEnabled
    }),
    sportsAnimalRacingRace({ eventTypeId: Number(eventTypeId) }),
    ...(isIspAnimalRacingSpecialsPagesEnabled ? [sportsAnimalRacingSpecials] : []),
    /* sportsTennisCompetition takes precedence over sportsCompetition so goes above it */
    sportsCompetition({ alias: 'sportsTennisCompetition' }),
    sportsCompetition({ alias: 'sportsCompetition' }),
    sportsCompetitionOutrights,
    sportsEvent(),
    sportsGolfCompetition,
    sportsGolfMatches,
    sportsHome,
    sportsHistoricalBets,
    sportsInPlay,
    sportsInPlaySport,
    sportsMatchFiltering,
    sportsMyBets,
    sportsPromotion,
    sportsPromotions,
    sportsSettings,
    sportsSpecials,
    /* sportsLanding takes precedence over sportsSport so goes above it */
    sportsLanding,
    /* sportsSport takes precedence over sportsCompetitions so goes above it */
    sportsSport,
    sportsCompetitions,
    sportsSportInPlay,
    /* Sports Basic Layout */
    sportsEmbeddedHistoricalBets,
    sportsEmbeddedMyBets,
    sportsEmbeddedSettings,
    /* Sports Self Excluded Layout */
    sportsSelfExcluded,
    sportsSelfExcludedHistoricalBets,
    sportsSelfExcludedMyBets
  ];
};
